'use strict';
namespace liveChatSnapInModule {
    interface LiveChatSnapInConfig {
        SnapInScript: string;
        SnapInConfig: any;
    }

    interface LiveChatContact {
        fName: string;
        lName: string;
        phone: string;
        email: string;
        subject: string;
        chatKey: string;
    }

    export class LiveChatSnapInService {
        private config: LiveChatSnapInConfig = TRPCONFIG.Domain.LiveChat;
        private chatkey;
        private domains = {com: 'dnatatravel.com', comsa: 'dnatatravel.com.sa'};
        private contact: LiveChatContact = {
            fName: '',
            lName: '',
            phone: '',
            email: '',
            subject: '',
            chatKey: ''
        };

        private sentFlag: boolean = false;

        constructor (
            private cookieService,
            private dateUtil,
            private $http: Core.IHttpService,
            private $q
        ) {
            $(window).on('message', (event) => {
                let data = _.get(event, 'originalEvent.data.data', {});
                if (_.get(data, 'chasitorData.details.prechatDetails.length', 0) > 0 &&
                    _.get(data, 'params.getType', null) === 'error' &&
                    _.get(data, 'params.getErrorReason', null) === 'Unavailable') {
                    this.updateContactDetails(event);
                    this.setPostChatMissedForm(this.contact);
                }
            });
        }

        public initialise() : void {
            if (!window['embedded_svc']) {
                const script = document.createElement('script');
                script.setAttribute('src', this.config.SnapInScript);
                script.onload = () => {
                    this.initESW(null);
                };
                document.body.appendChild(script);
            } else {
                this.initESW(this.config.SnapInConfig.initScriptUrl);
            }

            this.waitFor(this.getButton,500,20).then(
                () => { this.updateClickHandler(); },
                (msg) => { this.log(msg); });
        }

        private getButton() {
            const button = $('#esw_button_online');
            if(button.length) {
                return true;
            }
            return false;
        }

        private updateClickHandler() {
            const button = $('#esw_button_online');
            button.removeAttr('onclick');
            button.on('click', () => {
                this.chatInitiate();
            });
        }

        private log(errorMsg) {
            if(TRPCONFIG.Domain.LiveChat.ShowMessages) {
                console.log(`LIVECHAT | ${errorMsg}`);
            }
        }

        private waitFor(cb, duration:number = 500, maxCount:number = 10) {
            var deferred = this.$q.defer();
            if(!cb) {
                deferred.reject('Callback not supplied');
            }
            var counter:number = 0;
            let interval:number;
            const callback = () => {
                if(counter === maxCount){
                    clearInterval(interval);
                    deferred.reject(`Attempt failed after ${maxCount} attempts`);
                } else {
                    if( !cb() ) {
                        counter ++;
                    } else {
                        clearInterval(interval);
                        deferred.resolve();
                    }
                }
            };
            interval = setInterval(callback, duration);

            return deferred.promise;
        }

        private makeid(){
            /*------Generate Chat Key-----*/
            let text = '';
            const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

            for( let i=0; i < 15; i++ ) {
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            }

            return text;
            /*-----------------------------------*/
        }

        private setCookie(cookieValue) {
            let cookieDuration = this.config.SnapInConfig.settings.cookieDuration || 365;
            let hostname = window.location.hostname;
            hostname = hostname.indexOf('m.') === 0 ? hostname.substr(2) : hostname;
            hostname = hostname.replace('pp.', '').replace('pp2.','');
            hostname = hostname.replace('m.', '').replace('www.', '');
            this.cookieService.set(_.get(TRPCONFIG, 'Domain.LiveChat.SnapInConfig.cookieName', 'key'),
                cookieValue,
                this.dateUtil.addDays(new Date(), cookieDuration),
                hostname);
        }

        public proactiveChat(){
            if(this.config.SnapInConfig.settings.runProactiveScript) {
                //Proactive Button Start

                let btnOnline = document.getElementById('esw_button_online'); //AgentOnline
                let btnOffline = document.getElementById('esw_button_offline');  //AgentOffline
                let checkTimer;

                let checkStatus = () => {
                    btnOnline = document.getElementById('esw_button_online');
                    btnOffline = document.getElementById('esw_button_offline');
                    if (btnOnline == null && btnOffline == null) {
                        return;
                    }
                    if ((btnOnline && _.get(btnOnline, 'style.display') === '')
                        || (btnOffline && _.get(btnOffline, 'style.display') === '')) {
                        //Agent is online/offline
                        clearInterval(checkTimer);
                        // Checks if agent online
                        if (btnOffline && _.get(btnOffline, 'style.display') === 'none') {
                            setTimeout(() => {
                                if($(this.config.SnapInConfig.settings.containerCheck).length === 0) {
                                    btnOnline && btnOnline.click();
                                }
                                //Open the chat window after 5 minutes
                            }, this.config.SnapInConfig.settings.proactiveScriptTimeout || 300000);
                        }
                    }
                };
                //TimeLoop to check change agent online/offline
                let timeout = _.get(this.config, 'SnapInConfig.settings.proactiveScriptCheckTimeout') || 500;
                checkTimer = setInterval(checkStatus, timeout);
                if(btnOffline) {
                    btnOffline.style.display = 'none';
                }

                //Proactive Button End
            }
        }

        public initESW(baseUrl) : void {

            let settings = <any>_.assign({},
                _.get(window,'embedded_svc.settings') || {},
                this.config.SnapInConfig.settings);

            this.chatkey = Date.now() + this.makeid();

            this.log(`initESW ${baseUrl} chatkey ${this.chatkey}`);

            if (_.get(settings, 'extraPrechatFormDetails')) {
                for (let i in settings.extraPrechatFormDetails) {
                    if (settings.extraPrechatFormDetails[i].label === 'URL') {
                        settings.extraPrechatFormDetails[i].value = window.location.href;
                    }
                    if ( settings.extraPrechatFormDetails[i].value === 'chatkey' ||
                        new RegExp('chat key','gi').test(settings.extraPrechatFormDetails[i].label)
                    ) {
                        settings.extraPrechatFormDetails[i].value = this.chatkey;
                    }
                }
            }

            let dynamicStorageDomain = _.get(this.config.SnapInConfig, 'dynamicStorageDomain', false);
            if(dynamicStorageDomain) {
                let storageDomain = _.get(settings, 'storageDomain', '');
                let splitStorageDomain = (window.location.hostname || storageDomain).split(storageDomain);
                let newStorageDomain = [storageDomain];
                if (splitStorageDomain.length > 1) {
                    newStorageDomain = newStorageDomain.concat(splitStorageDomain.slice(1));
                }
                settings.storageDomain = newStorageDomain.join('');
            }

            let hostname = window.location.hostname;
            hostname = hostname + (hostname.indexOf('m.') === 0 ? '' : settings.redirectBase);
            settings.postChatUrl = window.location.protocol + '//' + hostname + settings.postchatRedirect;
            window['embedded_svc'].settings = settings;

            window['embedded_svc'].init(
                this.config.SnapInConfig.baseCoreUrl,
                this.config.SnapInConfig.baseLiveAgentUrl,
                this.config.SnapInConfig.baseLiveAgentContentUrl,
                this.config.SnapInConfig.communityEndpointUrl,
                this.config.SnapInConfig.deploymentId,
                this.config.SnapInConfig.orgId,
                this.config.SnapInConfig.buttonId,
                this.config.SnapInConfig.releaseVersion,
                baseUrl,
                this.config.SnapInConfig.chasitorJsVersion,
                this.config.SnapInConfig.eswConfigDevName,
                this.config.SnapInConfig.eswLiveAgentDevName
            );

            this.proactiveChat();
        }

        //Contact Object to store contact information
        private updateContactDetails(event){
            let data = _.get(event, 'originalEvent.data.data.chasitorData.details.prechatDetails', []);
            this.contact.fName = _.get(data, '[0].value', this.contact.fName);
            this.contact.lName = _.get(data, '[1].value', this.contact.lName);
            this.contact.email = _.get(data, '[2].value', this.contact.email);
            this.contact.phone = _.get(data, '[3].value', this.contact.phone);
            this.contact.subject = _.get(data, '[4].value', this.contact.subject);
            this.contact.chatKey = this.chatkey;

            return this.contact;
        }

        //Custom method to initiate and reinitiate the chat in order to reinitialize the chat key each time the customer
        //clicks on the online button without refreshing the page.
        private chatInitiate(){
            this.chatkey = Date.now() + this.makeid();
            window['embedded_svc'].settings.extraPrechatFormDetails[1].value = this.chatkey;
            window['embedded_svc'].settings.extraPrechatFormDetails[2].value = this.chatkey;
            if(this.config.SnapInConfig.settings.dropCookie) {
                this.setCookie(this.chatkey);
            }
            this.sentFlag = false;
            window['embedded_svc'].initInteraction();
        }

        private setPostChatMissedForm(contact: LiveChatContact){
            let params = {
                chkey: contact.chatKey,
                fName: contact.fName,
                lName: contact.lName,
                email: contact.email,
                pNumber: contact.phone,
                subject: contact.subject
            };
            this.$http.get(this.config.SnapInConfig.PostChatFeedbackForm + '?' + $.param(params))
                .then(() => this.sentFlag = true);
        }
    }

    angular
        .module('liveChatSnapInModule')
        .service('liveChatSnapInService', LiveChatSnapInService);
}
